import { useMemo, useEffect } from "react";
import { UserAddOutlined } from "@ant-design/icons";
import SalesPersonSelect from "../../common/components/SalesPersonSelect";
import { COUNTRY_CODES } from "../../../../constants/countries";
import { Button, Col, Form, Select, Row } from "antd";

const filterByLabel = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

const getRazonSocial = (client) => {
    if (!client?.name) return "";
    const name = client.name.toUpperCase();
    if (name.includes("SAN PEDRO SULA")) return "CONSUMIDOR FINAL SPS";
    if (name.includes("PUNTO DE VENTA")) return "CONSUMIDOR FINAL";
    return "";
};

export const ClientSectionSlot = ({
    permissions,
    requiredFields,
    loading,
    clients,
    handleClientChange,
    handleAddClient,
    colegios,
    handleColegioChange,
    tpv,
    country,
}) => {
    const form = Form.useFormInstance();
    const showVendedor = country?.code !== COUNTRY_CODES.PARAGUAY;

    const clientOptions = useMemo(
        () =>
            clients?.map((client) => ({
                value: client.id,
                label: `${client.No || client.id} - ${client.name}${client.Numero_Identificacion_fiscal
                        ? ` - ${client.Numero_Identificacion_fiscal}`
                        : ""
                    }${client.No ? "" : " (Sin sincronizar)"}`,
            })) ?? [],
        [clients]
    );

    const colegioOptions = useMemo(
        () =>
            colegios?.map((c) => ({
                value: c.No,
                label: `${c.No} - ${c.nombre}`,
            })) ?? [],
        [colegios]
    );

    const defaultClient = useMemo(
        () =>
            tpv?.defaultCustomer && clients
                ? clients.find((c) => c.No === tpv.defaultCustomer)
                : null,
        [clients, tpv?.defaultCustomer]
    );

    useEffect(() => {
        if (!defaultClient || form.getFieldValue("Sell_to_Customer_No_")) return;
        form.setFieldsValue({
            Sell_to_Customer_No_: defaultClient.id,
            Razon_Social: getRazonSocial(defaultClient),
        });
        handleClientChange(defaultClient.id);
    }, [defaultClient, form, handleClientChange]);

    const onSelectClient = (clientId) => {
        const selected = clients?.find((c) => c.id === clientId);
        if (selected) form.setFieldValue("Razon_Social", getRazonSocial(selected));
        handleClientChange(clientId);
    };

    return (
        <>
            <Row gutter={16}>
                <Col span={permissions?.createClient ? 20 : 24}>
                    <Form.Item
                        name="Sell_to_Customer_No_"
                        label="Cliente"
                        rules={[
                            {
                                required: requiredFields?.cliente,
                                message: "Seleccione un cliente",
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            virtual
                            loading={loading}
                            optionFilterProp="label"
                            placeholder="Seleccione un cliente o busque por nombre/DNI"
                            options={clientOptions}
                            filterOption={filterByLabel}
                            onChange={onSelectClient}
                        />
                    </Form.Item>
                </Col>
                {permissions?.createClient && (
                    <Col
                        span={4}
                        style={{
                            display: "flex",
                            alignItems: "end",
                            paddingBottom: "24px",
                        }}
                    >
                        <Button
                            type="primary"
                            icon={<UserAddOutlined />}
                            onClick={handleAddClient}
                            title="Añadir nuevo cliente"
                            style={{ width: "100%" }}
                        />
                    </Col>
                )}
            </Row>
            <Row gutter={16}>
                <Col xs={24} sm={24}>
                    <Form.Item
                        name="Colegio"
                        label="Colegio"
                        rules={[
                            {
                                required: requiredFields?.colegio,
                                message: "Seleccione un colegio",
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            allowClear
                            loading={loading}
                            optionFilterProp="label"
                            placeholder="Seleccione un colegio"
                            options={colegioOptions}
                            filterOption={filterByLabel}
                            onChange={handleColegioChange}
                        />
                    </Form.Item>
                </Col>
            </Row>
            {showVendedor && <Row gutter={16}>
                <Col xs={24} sm={24}>
                    <SalesPersonSelect value={tpv?.cod_Vendedor ?? null} />
                </Col>
            </Row>}
        </>
    );
};
